/**
 * Creates a synonyms API backed by the legacy wsClient.
 * This is the adapter for the existing cloud web-service.
 */
function generatedMutationId() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `synonyms-${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

export function createLegacySynonymsApi({ client, mutationIdFactory = generatedMutationId } = {}) {
  // Lazy import to avoid circular dependency at module load time.
  // wsClient is a singleton created at app bootstrap.
  let _wsClient = client || null;
  let revision = 0;
  let pendingMutation = null;

  function getClient() {
    if (!_wsClient) {
      // eslint-disable-next-line global-require
      const { wsClient } = require('util/appUtils');
      _wsClient = wsClient;
    }
    return _wsClient;
  }

  return {
    /**
     * @param {string} shopId
     * @returns {Promise<{ synonyms: Array }>}
     */
    async load(shopId) {
      const response = await getClient().getSearchSynonyms(shopId);
      revision = Number(response?.revision || 0);
      pendingMutation = null;
      return response;
    },

    /**
     * @param {string} shopId
     * @param {Array} synonyms
     * @returns {Promise<{ synonyms: Array }>}
     */
    async save(shopId, synonyms) {
      const signature = JSON.stringify(synonyms);
      if (!pendingMutation || pendingMutation.signature !== signature) {
        pendingMutation = { signature, id: mutationIdFactory() };
      }
      const response = await getClient().prepareRequest(
        'POST',
        `/system/shop/${encodeURIComponent(shopId)}/customization/search/synonym`,
        {
          body: {
            synonyms,
            expected_revision: revision,
            client_mutation_id: pendingMutation.id,
          },
        },
      );
      revision = Number(response?.revision || revision);
      pendingMutation = null;
      return response;
    },
  };
}
